const SETTINGS = {
    firstDelay: { min: 2000, max: 5000 },
    interval: { min: 3000, max: 8000 },
    duration: { min: 0.7, max: 1.2 },
    length: { min: 0.7, max: 1.35 },
    travel: { min: 1.6, max: 2.4 },
    angle: { min: 16, max: 34 },
    upperRightRatio: 0.7,
    upperRight: { x: { min: 58, max: 96 }, y: { min: 3, max: 34 } },
    wide: { x: { min: 28, max: 92 }, y: { min: 8, max: 46 } },
};

export default class Meteor {
    constructor() {
        this.$root = document.querySelector(".character__meteors");
        if (!this.$root) return;

        this.schedule(this.random(SETTINGS.firstDelay.min, SETTINGS.firstDelay.max));
    }

    schedule(delay) {
        window.setTimeout(() => {
            this.fire();
        }, delay);
    }

    fire() {
        if (!document.hidden) {
            this.$root.appendChild(this.createMeteor());
        }

        this.schedule(this.random(SETTINGS.interval.min, SETTINGS.interval.max));
    }

    createMeteor() {
        const $meteor = document.createElement("span");
        const angle = this.random(SETTINGS.angle.min, SETTINGS.angle.max);
        const area = Math.random() < SETTINGS.upperRightRatio ? SETTINGS.upperRight : SETTINGS.wide;

        $meteor.className = "character__meteor";
        $meteor.style.setProperty("--charaMeteorX", `${this.random(area.x.min, area.x.max).toFixed(2)}%`);
        $meteor.style.setProperty("--charaMeteorY", `${this.random(area.y.min, area.y.max).toFixed(2)}%`);
        $meteor.style.setProperty("--charaMeteorAngle", `${(180 - angle).toFixed(2)}deg`);
        $meteor.style.setProperty("--charaMeteorLen", this.random(SETTINGS.length.min, SETTINGS.length.max).toFixed(2));
        $meteor.style.setProperty("--charaMeteorTravel", this.random(SETTINGS.travel.min, SETTINGS.travel.max).toFixed(2));
        $meteor.style.setProperty("--charaMeteorDur", `${this.random(SETTINGS.duration.min, SETTINGS.duration.max).toFixed(2)}s`);

        $meteor.addEventListener(
            "animationend",
            () => {
                $meteor.remove();
            },
            { once: true }
        );

        return $meteor;
    }

    random(min, max) {
        return min + Math.random() * (max - min);
    }
}
